import useMediaQuery from "../../hooks/useMediaQuery";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import logo from "../../assets/icons/logo.svg";
import { GlobalSearch } from "./components/globalSearch/globalSearch";
import { Routes } from "./components/routes/routes";
import { smoothScroll } from "../../utils/helpers";
import styles from "./header.module.scss";

export const Header = () => {
  const { t } = useTranslation();
  const { language } = useParams();
  const { pathname } = useLocation();

  const lapropFirst = useMediaQuery("( max-width: 1123px )");
  const mobile = useMediaQuery("( max-width: 469px )");

  const [position, setPosition] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setPosition(window.scrollY);

    const handleScroll = () => {
      const moving = window.scrollY;
      setVisible(position > moving);
      setPosition(moving);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [position]);

  const hanldeClick = () => {
    pathname === `/${language}` ? smoothScroll() : null;
  };

  return (
    <header className={visible ? styles.header : styles.header_hidden}>
      <div className="container">
        <div className={styles.header_top}>
          <NavLink
            to={`/${language}`}
            className={styles.header_logo}
            onClick={hanldeClick}
          >
            <img src={logo} alt="logo" fetchPriority="high" />
            <p style={{ lineHeight: mobile && language === "en" && "48px" }}>
              {t("webname")}
            </p>
          </NavLink>
          <div className={styles.header_right}>
            <GlobalSearch />
          </div>
        </div>
      </div>

      <div style={{ background: lapropFirst ? "#DCDCDC" : "#fff" }}>
        <div className="container">
          <Routes />
        </div>
      </div>
    </header>
  );
};
